import request from '@/utils/request'

export function getCustomerServiceList(params) {
  return request({
    url: '/customerservice/list',
    method: 'get',
    params
  })
}

export function getCustomerServiceInfo(id) {
  return request({
    url: `/customerservice/${id}`,
    method: 'get'
  })
}

export function saveCustomerService(data) {
  return request({
    url: '/customerservice/save',
    method: 'post',
    data
  })
}

export function updateCustomerService(data) {
  return request({
    url: '/customerservice/update',
    method: 'put',
    data
  })
}

export function deleteCustomerService(id) {
  return request({
    url: `/customerservice/${id}`,
    method: 'delete'
  })
}

export function getChatClientList(params) {
  return request({
    url: '/chat/client/list',
    method: 'get',
    params
  })
}

export function getMessage(params) {
  return request({
    url: '/chat/message/list',
    method: 'get',
    params
  })
}